export default __webpack_public_path__ + "static/media/dinner-room.7ee872cb.svg";